export function init() {
    let articleAside = document.querySelector('.article__aside');
    if (articleAside != null) {
        document.querySelector('.main').style.overflow = "initial";
    }
}

